__turbopack_context__.v({
  "caret": "CategoryFilterDropdown-module__yg6ZTW__caret",
  "item": "CategoryFilterDropdown-module__yg6ZTW__item",
  "itemCount": "CategoryFilterDropdown-module__yg6ZTW__itemCount",
  "menu": "CategoryFilterDropdown-module__yg6ZTW__menu",
  "trigger": "CategoryFilterDropdown-module__yg6ZTW__trigger",
  "triggerCount": "CategoryFilterDropdown-module__yg6ZTW__triggerCount",
  "wrap": "CategoryFilterDropdown-module__yg6ZTW__wrap",
});
